// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"Video_videoContainer__9rTAy","iframeWrapper":"Video_iframeWrapper__1cxa1"};